import { useState } from "react";
import { PatternSelector } from "./PatternSelector";
import { slotPatterns, textureSrc } from "@/lib/catalog";

// Escolha de modelo e padrão por parte da peça (elástico, orelhas e gola, cada babete de um pack...).
export function SlotPicker({ product, value, onChange, pending = () => false }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-3" data-testid="slot-picker">
      {product.slots.filter((s) => !s.suggested).map((s) => {
        const list = slotPatterns(product, s);
        const v = value[s.id] ?? {};
        const cur = list.find((p) => p.id === v.patternId);
        const isOpen = open === s.id;
        // Padrão ainda por escolher (o que se vê é só o ponto de partida): não o mostramos como se já estivesse escolhido.
        const todo = pending(s);
        return (
          <div key={s.id} className="rounded-2xl border border-ink/10 bg-ivory p-3.5" data-testid={`slot-${s.id}`}>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2.5">
              <p className="min-w-[7rem] text-sm font-semibold text-ink">{s.label}</p>
              {s.models?.length > 0 && (
                <div className="flex gap-1.5" role="radiogroup" aria-label={`Modelo: ${s.label}`}>
                  {s.models.map((m) => (
                    <button key={m.id} type="button" role="radio" aria-checked={v.modelId === m.id} data-testid={`slot-${s.id}-model-${m.id}`} onClick={() => onChange(s.id, { modelId: m.id })} className={`min-h-[36px] rounded-full border px-3.5 text-xs transition-colors ${v.modelId === m.id ? "border-bordeaux bg-rose-soft font-semibold text-bordeaux" : "border-ink/15 text-ink hover:border-bordeaux/40"}`}>{m.label}</button>
                  ))}
                </div>
              )}
              <button type="button" aria-expanded={isOpen} data-testid={`slot-${s.id}-toggle`} onClick={() => setOpen(isOpen ? null : s.id)} className={`flex min-h-[44px] w-full items-center gap-2.5 rounded-full py-1 pl-1 pr-3.5 text-left text-xs transition-colors hover:bg-rose-soft sm:ml-auto sm:w-auto ${todo ? "border border-dashed border-bordeaux/50 bg-rose-soft/50 pl-3.5" : "bg-linen/70"}`}>
                {cur && !todo && <img src={textureSrc(cur.texture, 240)} alt="" className="h-9 w-9 rounded-full object-cover" />}
                <span className="min-w-0 flex-1 truncate font-medium text-ink sm:max-w-[10rem] sm:flex-none" data-testid={`slot-${s.id}-name`}>{todo ? "Escolher o padrão" : cur?.name ?? "Escolher"}</span>
                <span className="shrink-0 text-bordeaux">{isOpen ? "Fechar" : todo ? "Escolher" : "Alterar"}</span>
              </button>
            </div>
            {isOpen && (
              <div className="mt-4 border-t border-ink/10 pt-4">
                <PatternSelector legend={`Padrão: ${s.label}`} showPreview={false} patterns={list} value={v.patternId} onChange={(id) => { onChange(s.id, { patternId: id }); setOpen(null); }} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
